module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.84ce936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/title-banner1-type2.png
// module id = m2LI
// module chunks = 1